<!--
  File name: FormRow.vue
  Program Description:
    - This component renders the assigned values passed on the `FormLabel.vue`
    file from the parent component.
  Includes:
    * FormLabel
-->
<template>
  <v-row
    v-if="fields && fields.length"
    class="pa-3 ma-10"
  >
    <v-col
      v-for="(input, idx) in fields"
      :key="idx"
    >
      <FormLabel :input="input" />
    </v-col>
  </v-row>
</template>

<script>
import FormLabel from './FormLabel.vue'

export default {
  components: {
    FormLabel
  },
  props: {
    fields: {
      type: Array,
      default: () => []
    }
  }
}
</script>
